import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_AUTH } from '../routes/paths';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, isSelectedSchool } = useAuth();

  const { pathname } = useLocation();

  let navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated && isSelectedSchool) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if (isAuthenticated && pathname !== PATH_AUTH.merchant) {
    return <Navigate to={PATH_AUTH.merchant} />;
  }

  return <>{children}</>;
}
